module.exports = __webpack_public_path__ + "media/images/icons/user-white-714d86525aa0f4334b37eb5e9650b549.svg";